import { PRIVATE_HTTP as http } from '../http-common';

const incident = async (id: number) => {
  return http().get(`/api/v4/complaints/${id}`);
};

const incidents = async () => {
  // return http().get(`/api/v4/complaints`);
  return http().get(`/api/v4/complaints?status=open`);
};

const createIncidentAPI = async (body: any) => {
  return http().post(`/api/v4/complaints`, body);
};

const uploadPhotoComplaint = async (formData: FormData) => {
  return http({ formData: true }).post(
    `/api/v4/complaints/upload_photo`,
    formData
  );
};

const incidentsInsuranceCompanies = async () => {
  return http().get(`/api/v4/insurance_companies`);
};

export {
  incident,
  incidents,
  createIncidentAPI,
  uploadPhotoComplaint,
  incidentsInsuranceCompanies,
};
